import { render, staticRenderFns } from "./rtc.vue?vue&type=template&id=161b9c77&scoped=true&"
import script from "./rtc.vue?vue&type=script&lang=js&"
export * from "./rtc.vue?vue&type=script&lang=js&"
import style0 from "./rtc.vue?vue&type=style&index=0&id=161b9c77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161b9c77",
  null
  
)

export default component.exports